import {
    FETCH_PLAYER_FOLDERS_BEGIN,
    FETCH_PLAYER_FOLDERS_ERROR,
    FETCH_PLAYER_FOLDERS_SUCCESS
} from "../actions/player/playerFolderActions";
import {
    FETCH_PLAYER_MEDIA_LIST_BEGIN,
    FETCH_PLAYER_MEDIA_LIST_ERROR,
    FETCH_PLAYER_MEDIA_LIST_SUCCESS
} from "../actions/player/playerMediaActions";

const defaultPlayerFolders = {
    playerFolders: [],
    pagination: {},
    loading: false,
    error: null
};

const defaultPlayerMediaList = {
    playerMediaList: [],
    pagination: {},
    loading: false,
    error: null
}

export const playerFolders = (state = defaultPlayerFolders, action) => {
    switch (action.type) {
        case FETCH_PLAYER_FOLDERS_BEGIN:
            return {
                ...state,
                loading: true,
                error: null
            };
        case FETCH_PLAYER_FOLDERS_SUCCESS:
            return {
                ...state,
                loading: false,
                playerFolders: action.payload.playerFolders,
                pagination: {
                    numberOfElements: action.payload.numberOfElements,
                    totalElements: action.payload.totalElements,
                    totalPages: action.payload.totalPages
                },
            };
        case FETCH_PLAYER_FOLDERS_ERROR:
            return {
                ...state,
                loading: false,
                playerFolders: [],
                error: action.payload.error
            };
        default:
            return state;
    }
};

export const playerMediaList = (state = defaultPlayerMediaList, action) => {
    switch (action.type) {
        case FETCH_PLAYER_MEDIA_LIST_BEGIN:
            return {
                ...state,
                loading: true,
                error: null
            };

        case FETCH_PLAYER_MEDIA_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                playerMediaList: action.payload.playerMediaList,
                pagination: {
                    numberOfElements: action.payload.numberOfElements,
                    totalElements: action.payload.totalElements,
                    totalPages: action.payload.totalPages
                },
            };
        case FETCH_PLAYER_MEDIA_LIST_ERROR:
            return {
                ...state,
                loading: false,
                playerMediaList: [],
                error: action.payload.error
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/player.js